import { useQuery } from "@tanstack/react-query";

import { getNextActions } from "@/modules/lead-page/api/lead-page.api";
import { queryCommonFlags } from "@/api/constants";
import { useContext } from "react";
import { LeadPageContext } from "../../context/lead-page.context";

const useGetNextActions = () => {
  const { lead } = useContext(LeadPageContext);

  const {
    data: nextActionsData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["getNextActions", lead?.data.uid],
    queryFn: () => getNextActions(lead?.data.uid),
    ...queryCommonFlags,
    enabled: !!lead,
    staleTime: Infinity,
  });
  return {
    nextActionsData: nextActionsData?.data.sort((a, b) => {
      return (
        new Date(a.actionTime).getTime() - new Date(b.actionTime).getTime()
      );
    }),
    isError,
    isLoading,
  };
};

export default useGetNextActions;
